import styled from '@mui/system/styled';

export const TaskListCnt = styled('div')({
  padding: '0 24px',
  width: '100%',
});
